@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.widget {
  width: 100%;
  position: relative;
  border: 1px solid @shipment-configuration-widget--border-color;
  border-radius: 4px;
  background-color: @shipment-configuration-widget--background-color;
  color: @shipment-configuration-widget--text-color;
  box-shadow: 1px 1px 3px @shipment-configuration-widget--box-shadow-color;
}

.service {
  position: relative;
}

.reason-row > div:first-child {
  width: 100%;
}

.primary-single-action > div {
  & > div {
    display: none;
  }

  & > button {
    border-radius: 4px;
  }
}
